import localFetch from "@/modules/instances/localFetch";

/**
 * Local/self-hosted mode: deletes a real API key via the local backend
 * (DELETE /v1/auth/api-keys/{id}). See getApiKeys.ts for why this replaces
 * the upstream OSS stub.
 */
export default async function deleteApiKey(keyId: string): Promise<void> {
  await localFetch(`/v1/auth/api-keys/${encodeURIComponent(keyId)}`, {
    method: "DELETE",
  });
}
